var _div;
import React from 'react';
import { Heading } from 'reaxl';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function VHRLeadHeading() {
  return _div || (_div = /*#__PURE__*/_jsxs("div", {
    className: "margin-bottom-4",
    children: [/*#__PURE__*/_jsx(Heading, {
      size: 400,
      className: "margin-bottom-2",
      children: "Get a Free Report in Seconds"
    }), /*#__PURE__*/_jsx("p", {
      children: "We'll let the dealer know you're interested in learning more about the history of this vehicle."
    })]
  }));
}
export default VHRLeadHeading;